// extracted by mini-css-extract-plugin
export default {"slider":"Depoimentos_slider__xfi1B","generalContent":"Depoimentos_generalContent__wTgDN"};